import { DefaultActionsDetails } from '@msdk/definitions'

export interface ActionLabels {
  description: string
  title: string
  body: string
  confirmationLabel: string
  success: string
  error: string
  iconTag: string
}

function getActionLabel(
  overriddenIDML: string | undefined,
  overriddenDescription: string | undefined,
  IDML: string,
  description: string,
  t: (idml: string, description: string) => string,
): string {
  return overriddenIDML ? t(overriddenIDML, overriddenDescription ?? '') : t(IDML, description)
}

export function getActivateActionLabels(
  actionDetails: DefaultActionsDetails | undefined,
  t: (idml: string, description: string) => string,
): ActionLabels {
  return {
    description: getActionLabel(
      actionDetails?.overrideIDML,
      actionDetails?.overrideDescription,
      'CMPSR_ACTIVATE',
      'Activate',
      t,
    ),
    success: getActionLabel(
      actionDetails?.success?.idml,
      actionDetails?.success?.description,
      'CMPSR_ACTION_ACTIVATE_SUCCESS',
      'Activation successful',
      t,
    ),
    error: getActionLabel(
      actionDetails?.error?.idml,
      actionDetails?.error?.description,
      'CMPSR_ACTION_ACTIVATE_ERROR',
      'Activation failed',
      t,
    ),
    title: getActionLabel(
      actionDetails?.title?.idml,
      actionDetails?.title?.description,
      'LBL_MODALTITLE_RESTORE',
      'Restore selected item?',
      t,
    ),
    body: getActionLabel(
      actionDetails?.description?.idml,
      actionDetails?.description?.description,
      'LBL_MODALMESSAGE_RESTORE',
      'This action will restore the selected item.',
      t,
    ),
    confirmationLabel: getActionLabel(
      actionDetails?.confirmationLabel?.idml,
      actionDetails?.confirmationLabel?.description,
      'CMPSR_ACTION_CONFIRMATION_ACTIVATE',
      'Activate',
      t,
    ),
    iconTag: actionDetails?.iconTag ? actionDetails?.iconTag : 'PowerSettingsNewOutlined',
  }
}

export function getDectivateActionLabels(
  actionDetails: DefaultActionsDetails | undefined,
  t: (idml: string, description: string) => string,
): ActionLabels {
  return {
    description: getActionLabel(
      actionDetails?.overrideIDML,
      actionDetails?.overrideDescription,
      'CMPSR_DEACTIVATE',
      'Deactivate',
      t,
    ),
    success: getActionLabel(
      actionDetails?.success?.idml,
      actionDetails?.success?.description,
      'CMPSR_ACTION_DEACTIVATE_SUCCESS',
      'Deactivation successful',
      t,
    ),
    error: getActionLabel(
      actionDetails?.error?.idml,
      actionDetails?.error?.description,
      'CMPSR_ACTION_DEACTIVATE_ERROR',
      'Deactivation failed',
      t,
    ),
    title: getActionLabel(
      actionDetails?.title?.idml,
      actionDetails?.title?.description,
      'LBL_MODAL_TOBIN_TITLE',
      'Move the selected item to the bin?',
      t,
    ),
    body: getActionLabel(
      actionDetails?.description?.idml,
      actionDetails?.description?.description,
      'LBL_MODAL_TOBIN_MESSAGE',
      'This action moves the selected item to the bin. You can restore this later.',
      t,
    ),
    confirmationLabel: getActionLabel(
      actionDetails?.confirmationLabel?.idml,
      actionDetails?.confirmationLabel?.description,
      'CMPSR_ACTION_CONFIRMATION_DEACTIVATE',
      'Deactivate',
      t,
    ),
    iconTag: actionDetails?.iconTag ? actionDetails.iconTag : 'BlockOutlined',
  }
}

export function getDeleteActionLabels(
  actionDetails: DefaultActionsDetails | undefined,
  t: (idml: string, description: string) => string,
): ActionLabels {
  return {
    description: getActionLabel(
      actionDetails?.overrideIDML,
      actionDetails?.overrideDescription,
      'CMPSR_DELETE_FOREVER',
      'Delete forever',
      t,
    ),
    success: getActionLabel(
      actionDetails?.success?.idml,
      actionDetails?.success?.description,
      'CMPSR_ACTION_DELETE_SUCCESS',
      'Delete successful',
      t,
    ),
    error: getActionLabel(
      actionDetails?.error?.idml,
      actionDetails?.error?.description,
      'CMPSR_ACTION_DELETE_ERROR',
      'Delete failed',
      t,
    ),
    title: getActionLabel(
      actionDetails?.title?.idml,
      actionDetails?.title?.description,
      'LBL_MODAL_TOBIN_TITLE',
      'Move the selected item to the bin?',
      t,
    ),
    body: getActionLabel(
      actionDetails?.description?.idml,
      actionDetails?.description?.description,
      'LBL_MODAL_TOBIN_MESSAGE',
      'This action moves the selected item to the bin. You can restore this later.',
      t,
    ),
    confirmationLabel: getActionLabel(
      actionDetails?.confirmationLabel?.idml,
      actionDetails?.confirmationLabel?.description,
      'CMPSR_ACTION_CONFIRMATION_DELETE',
      'Delete forever',
      t,
    ),
    iconTag: actionDetails?.iconTag ? actionDetails.iconTag : 'DeleteOutlined',
  }
}

export function getEditActionLabels(
  actionDetails: DefaultActionsDetails | undefined,
  t: (idml: string, description: string) => string,
): ActionLabels {
  return {
    description: getActionLabel(
      actionDetails?.overrideIDML,
      actionDetails?.overrideDescription,
      'CMPSR_EDIT',
      'Edit',
      t,
    ),
    success: '',
    error: '',
    title: '',
    body: '',
    confirmationLabel: '',
    iconTag: actionDetails?.iconTag ? actionDetails.iconTag : 'EditOutlined',
  }
}
